// extracted by mini-css-extract-plugin
module.exports = {"stage":"styles_stage__2m0tJ","access":"styles_access__2evb0","profileImage":"styles_profileImage__1J9fO"};